/** Ids of the built-in pills: their settings keys, and their category or board ids. Kept import-free so the settings schema, parsed with every dashboard config, doesn't pull in the pill modules. */
export const STAGE_CATEGORY = 'stage'
export const VERSION_CATEGORY = 'version'
export const CREATOR_CATEGORY = 'creator'
export const SIGNOFFS_ID = 'signoffs'
export const COMMENTS_CATEGORY = 'comments'
